import React, { useState, useCallback } from "react";
import crStyles from "../../../customerReservation/crStyles";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import styles from "./WallBoxDetails.module.scss";
import FormControl from "@mui/material/FormControl";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../shared/checkBox/CheckBox.module.scss";
import { withTranslation } from "react-i18next";
import CapitalizeText from "../../../../utils/CapitalizeText";
import UiDateUtils from "../../../../utils/UiDateUtils";
import {
  StyledExpansionPanel,
  StyledExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";

function WallBoxDetails({ t, isOrderCancelled, customerReservation }) {
  const [expandWallBoxDetails, setExpandWallBoxDetails] = useState(true);

  const handleExpandWallBoxDetails = useCallback(() => {
    setExpandWallBoxDetails(prev => !prev);
  }, []);

  return (
    <div>
      <StyledExpansionPanel
        defaultExpanded={true}
        onChange={handleExpandWallBoxDetails}
      >
        <StyledExpansionPanelSummary style={crStyles.headerBarBg}>
          <div className={sharedStyles.headerBar}>
            <div data-testid="wallBoxTitleId" className={sharedStyles.header}>
              {t("WallBox.wallBoxTitle")}
            </div>
            <div>
              {expandWallBoxDetails ? (
                <ExpandLessIcon id="less_id" />
              ) : (
                <ExpandMoreIcon id="more_id" />
              )}
            </div>
          </div>
        </StyledExpansionPanelSummary>
        {isOrderCancelled(customerReservation.status) && (
          <div className={styles.overlay} data-testid="wallboxOverlay" />
        )}
        <div className={styles.wallBoxInfo}>
          <FormControl>
            <CheckBox
              id="wallboxRequestedDateCheckboxId"
              checked={true}
              isDisabled={true}
              label={CapitalizeText(t("WallBox.installationRequestedTitle"))}
              textClass={checkboxStyles.boldLabel}
            />
            <div className={styles.info}>
              <span className={styles.installationRequestedDate}>
                {UiDateUtils.formattedDate(
                  customerReservation.chargingInstallationRequestDate
                )}
              </span>
              <span className={styles.installationRequestedCaption}>
                {t("WallBox.installationRequestedCaption")}
              </span>
            </div>
          </FormControl>
        </div>
      </StyledExpansionPanel>
    </div>
  );
}

export default withTranslation("emp")(WallBoxDetails);
